import { render, staticRenderFns } from "./CbmCard.vue?vue&type=template&id=9be8b364&scoped=true"
import script from "./CbmCard.vue?vue&type=script&lang=js"
export * from "./CbmCard.vue?vue&type=script&lang=js"
import style0 from "./CbmCard.vue?vue&type=style&index=0&id=9be8b364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be8b364",
  null
  
)

export default component.exports